import { createContext } from '@lit/context';

/**
 * Whether a `<cos-help-dock>` ancestor is both present and currently wide
 * enough to render its side panel (see cos-help-dock.ts). Every cos-* field
 * primitive consumes this (subscribed, so it updates live as the dock's own
 * width crosses its breakpoint) to decide whether to keep rendering its own
 * `helpText` visibly or hand that job to the dock and clip its own copy out
 * of view instead. With no `<cos-help-dock>` ancestor a primitive gets the
 * default `false` and renders exactly as it always has.
 */
export const fieldHelpDockActiveContext = createContext<boolean>('cos-field-help-dock-active');
